import notification from "@verivest/shared-components/src/configure-store/reducers/notifications";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  notification,
});

export default rootReducer;
